// Per-browser favorites for the Tickets list (mirrors the Companies pattern).
// Stored in localStorage so the feature works without backend changes and
// survives reloads. The key is namespaced per logged-in admin so two admins
// on the same browser don't share their favorite lists.

const KEY_PREFIX = "wa.tickets.favorites";

const getKey = (userId) => `${KEY_PREFIX}.${userId || "anon"}`;

export const readTicketFavorites = (userId) => {
  try {
    const raw = localStorage.getItem(getKey(userId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const writeTicketFavorites = (userId, ids) => {
  try {
    localStorage.setItem(getKey(userId), JSON.stringify(ids));
  } catch {
    /* localStorage may be disabled — silently ignore */
  }
};

export const isTicketFavorite = (favorites, ticketId) =>
  Array.isArray(favorites) && favorites.includes(String(ticketId));

export const toggleTicketFavorite = (favorites, ticketId) => {
  const id = String(ticketId);
  const set = new Set(Array.isArray(favorites) ? favorites : []);
  if (set.has(id)) set.delete(id);
  else set.add(id);
  return Array.from(set);
};
